import React from "react";
import ModalWrapper from "components/common/ModalWrapper";
import DemandTypeCompareChart from "./DemandTypeCompareChart";
import {
  useAnatomyFilter,
  useAnatomyData,
  useAnatomyUI,
} from "./context/AnatomyContexts";

class DemandTypeCompareModalInner extends React.PureComponent {
  constructor(props) {
    super(props);

    const { detailChartProps } = props;

    this.state = {
      groupType: detailChartProps.groupType,
      layerNum: detailChartProps.layerNum,
      metric: detailChartProps.metric,
    };
  }

  render() {
    const {
      isOpenViewModal,
      handleClose,
      unitInfo,
      data,
      groupTypes,
      getFilterParams,
      timezoneType,
    } = this.props;
    const { groupType, layerNum, metric } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpenViewModal}
        showCloseFooter={true}
        handleClose={handleClose}
        title="Performance by Demand Type Groups"
      >
        <div className="overflow-y-auto" style={{ maxHeight: "600px" }}>
          <DemandTypeCompareChart
            unitInfo={unitInfo}
            data={data}
            groupTypes={groupTypes} // all groupTypes
            getFilterParams={getFilterParams}
            groupType={groupType}
            layerNum={layerNum}
            metric={metric}
            timezoneType={timezoneType}
          ></DemandTypeCompareChart>
        </div>
      </ModalWrapper>
    );
  }
}

const DemandTypeCompareModal = React.memo((props) => {
  const filterContext = useAnatomyFilter();
  const dataContext = useAnatomyData();
  const uiContext = useAnatomyUI();

  if (!filterContext || !dataContext || !uiContext) {
    return <DemandTypeCompareModalInner {...props} />;
  }

  return (
    <DemandTypeCompareModalInner
      {...props}
      isOpenViewModal={uiContext.isModalOpen}
      timezoneType={filterContext.timezoneType}
      handleClose={uiContext.handleCloseModal}
      detailChartProps={uiContext.detailChartProps}
      unitInfo={dataContext.unitInfo}
      data={dataContext.segmentData}
      groupTypes={dataContext.filteredData && dataContext.filteredData.groupTypes}
      getFilterParams={filterContext.getFilterParams}
    />
  );
});

export default DemandTypeCompareModal;
